import React, { useState } from "react";
import "./heavy_bleeding_template_date.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function HeavyBleedingTemplates(props) {
  const [show, setShow] = useState(false);
  const [formValues, setFormValues] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });

  let bmiValue =
    formValues?.height && formValues?.weight
      ? ((formValues.weight / formValues.height ** 2) * 10000).toFixed(2)
      : "";
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const [rows, setRows] = useState([
    {
      diabeteshypertensiontoother: "",
      duration: "",
      medications: "",
    },
  ]);
  const [investiRows, setInvestiRows] = useState([
    {
      drug: "",
      dosageno: "",
      frequency: "",
      relationwithfood: "",
      duration: "",
    },
  ]);

  const investiRowAdd = () => {
    setInvestiRows([
      ...investiRows,
      {
        drug: "",
        dosageno: "",
        frequency: "",
        relationwithfood: "",
        duration: "",
      },
    ]);
  };
  const investiRowRemove = (i) => {
    let newInvest = investiRows.filter((row, ind) => i !== ind);
    setInvestiRows(newInvest);
  };

  const handleInvestiValue = (ind, e) => {
    const { name, value } = e.target;
    const newRows = [...investiRows];
    newRows[ind][name] = value;
    setInvestiRows(newRows);
  };
  const handleRemoveRow = (i) => {
    const nowRow = rows.filter((row, ind) => i !== ind);
    setRows(nowRow);
  };

  const handleTableValue = (index, e) => {
    const { name, value } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);
  };
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        diabeteshypertensiontoother: "",
        duration: "",
        medications: "",
      },
    ]);
  };

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormValues({ ...formValues, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormValues({
                ...formValues,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormValues({
            ...formValues,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormValues({ ...formValues, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: "Not Visited",
          notes: "Booking Visit",
          patient_id: patientId,
        });
      }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };
  const renderTableTD = (value) => {
    return (
      <td style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </td>
    );
  };
  const renderTableTH = (value) => {
    return (
      <th style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </th>
    );
  };
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: "20px",
        // lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        height: "20px",
      }}
    >
      ●
    </span>
  );
  const renderIndentation = () => (
    <span
      style={{
        visibility: "hidden",
        fontSize: "30px",
        lineHeight: "20px",
      }}
    >
      ●
    </span>
  );
  const renderInput = (name, type = "text", size) => (
    <>
      <input
        type={type}
        name={name}
        className={`createTime ${show ? "hide" : "show"}`}
        onChange={handleChange}
        style={{ width: size }}
      />
    </>
  );

  const handlesubmit = () => {
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setShow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "heavyBleedingReportWarp"
          ).innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Heavy Bleeding Template Date",
            },
          };
          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            // Swal.fire({
            //   title: "Successful.",
            //   text: "Record added successful.",
            //   icon: "success",
            //   showConfirmButton: false,
            //   timer: 1500,
            // });
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="HeavyBleedingTemplates">
      <div className="HeavyBleedingTemplates">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px"

            }}
          > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={formValues.patientId1}
                  onChange={(e) => handleChange(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formValues.patientId1}
                </span>
              </div>
            </div> */}

          {/* Patient Name */}
          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formValues.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{formValues.patientName1}
              </span>
            </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={formValues.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formValues.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formValues.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formValues.age1}
              </span>
            </div> */}

          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={formValues.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formValues.bloodGroup1}
              </span>
            </div> */}
          {/* </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <div className="detail">
          <h2>
            HEAVY BLEEDING Template{" "}
            <span>
              Date{" "}
              <input
                type="date"
                className={`createTime ${show ? "hide" : "show"}`}
                name="date"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formValues.date}
              </span>
            </span>
          </h2>
          <p>
            Name:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="name"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.name}
            </span>
            Age:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="age"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.age}
            </span>
          </p>
          <p>
            UHID (Should come automatically){" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="uhid"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.uhid}
            </span>
          </p>
          <p>
            Occupation{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="occupation"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.occupation}
            </span>
          </p>
          <p>
            C/O Bleeding PV{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="cobleedingpv"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.cobleedingpv}
            </span>
            days/months
          </p>
          <p>
            C/o Passing clots{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="copassingclots"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.copassingclots}
            </span>
          </p>
          <p>
            C/o pain during periods{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="copainperiods"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.copainperiods}
            </span>
          </p>
          <p>
            C/O bleeding after intercourse{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="cobleedingintercourse"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.cobleedingintercourse}
            </span>
          </p>
          <p>
            C/O bleeding in between periods{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="cobleedingbetween"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.cobleedingbetween}
            </span>
          </p>
          <p>
            Others -{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="others"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.others}
            </span>
          </p>
          <br />
          <br />
          <p>
            Menstrual H/O{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="menstrualho"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.menstrualho}
            </span>
          </p>
          <p>
            LMP:{" "}
            <input
              type="date"
              className={`createTime ${show ? "hide" : "show"}`}
              name="lmp"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.lmp}
            </span>
          </p>
          <p>
            Cycles:{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="cycles"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Regular">Regular</option>
              <option value="Irregular">Irregular</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.cycles}
            </span>
          </p>
          <p>
            Frequency:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="frequency"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.frequency}
            </span>
          </p>
          <p>
            Pain during periods:{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="painperiods"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.painperiods}
            </span>
          </p>
          <br />
          <br />
          <p>
            Obstetric h/o{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="obstetricho"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.obstetricho}
            </span>
          </p>
          <br />
          <p>Prev --- Vaginal delivery</p>
          <p>Prev --- Cesarean</p>
          <p>
            Sterilization{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="sterilization"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.sterilization}
            </span>
          </p>
          <br />
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <caption>Past H/O</caption>
          <tbody>
            <tr>
              <th>
                Diabetes/ Hypertension/
                <br /> TB/ Hypothyroid/ Hyperthyroid/
                <br />
                Nil/ Others
              </th>
              <th>Duration</th>
              <th>Medications</th>
              <th>Actions</th>
            </tr>
            {rows.map((row, i) => (
              <tr key={i}>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={"diabeteshypertensiontoother"}
                    onChange={(e) => handleTableValue(i, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`condition${i}`]}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`duration`}
                    onChange={(e) => handleTableValue(i, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`duration${i}`]}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`medications`}
                    onChange={(e) => handleTableValue(i, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`medications${i}`]}
                  </span>
                </td>
                <td style={{ textAlign: "center" }}>
                  {i == 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={(e) => handleAddRow(i)}
                    >
                      +
                    </button>
                  )}
                  {i > 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={() => handleRemoveRow(i)}
                    >
                      -
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="detail">
          <p>
            On examination:{" "}
            {/* <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="onexamination"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.onexamination}
            </span> */}
          </p>
          <p>
            GC Fair, Hydration - Adequate;{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="gcfair"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.gcfair}
            </span>
          </p>
          <p>
            BP -{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="bp"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.bp}
            </span>
            mm/hg;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PR
            -{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pr"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.pr}
            </span>
          </p>
          <p>Height: {renderInput("height")} m</p>
          <p>Weight: {renderInput("weight")} KGs</p>
          <p>
            BMI:
            <input
              type="text"
              name="bmi"
              className={`createTime ${show ? "hide" : "show"}`}
              value={bmiValue}
            />
            KG/m<sup style={{ fontWeight: "bold" }}>2</sup>
          </p>
          <p>
            Per abdomen:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="perabdomen"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.perabdomen}
            </span>
          </p>
          <p>
            PS -{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="ps"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.ps}
            </span>
          </p>
          <p>
            PV -{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pv"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.pv}
            </span>
          </p>
          <p>
            Pap Smear/HPV{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="papsmear"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.papsmear}
            </span>
          </p>
          <p>
            Vaginal Swab{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="vaginalswab"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.vaginalswab}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lab:{" "}
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              name="lab"
              onChange={handleChange}
            >
              <option value="" selected disabled>
                Please Select
              </option>
              <option value="Third eye">Third eye</option>
              <option value="Karkinos">Karkinos</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.lab}
            </span>
          </p>
          <br />
          <br />
          <h2>Investigations</h2>
          <p>CBC ,FBS ,HbA1C,TSH,FT4</p>
          <p>USG Pelvis</p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>Sno</th>
              <th>Drug (Insert generic name)</th>
              <th>Dosage NUMBERS</th>
              <th>Frequency</th>
              <th>Relationship with food</th>
              <th>Duration</th>
              <th>Actions</th>
            </tr>
            {investiRows.map((ele, ind) => (
              <tr key={ind}>
                <td>{ind + 1}</td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`drug`}
                    onChange={(e) => handleInvestiValue(ind, e)}
                  />
                  {/* <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`drug${i}`]}
                  </span> */}
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`dosageno`}
                    onChange={(e) => handleInvestiValue(ind, e)}
                  />
                  {/* <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`dosage${i}`]}
                  </span> */}
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`frequency`}
                    onChange={(e) => handleInvestiValue(ind, e)}
                  />
                  {/* <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`frequency${i}`]}
                  </span> */}
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`relationwithfood`}
                    onChange={(e) => handleInvestiValue(ind, e)}
                  />
                  {/* <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`relation${i}`]}
                  </span> */}
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`duration`}
                    onChange={(e) => handleInvestiValue(ind, e)}
                  />
                  {/* <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formValues[`duration${i}`]}
                  </span> */}
                </td>
                <td>
                  {!ind && (
                    <button onClick={(e) => investiRowAdd(ind)}>+</button>
                  )}
                  {ind !== 0 && (
                    <button onClick={(e) => investiRowRemove(ind)}>-</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="bulletin">
          <ul>
            <li>
              Take your medications fully as per course as stopping hormonal
              pills in between can lead to bleeding again
            </li>
          </ul>
        </div>
        <br />
        <br />
        <div className="detail">
          <p>Information Leaflet</p>
          <p>Some of the causes of heavy bleeding</p>
        </div>
        <div className="bulletin">
          <ul>
            <li>
              Fibroids and polyps - Common bumps in uterus and inside the uterus
            </li>
            <li>Adenomyosis - Thick walls of uterus</li>
            <li>
              Hormonal imbalance and Irregular ovulation — If you do not ovulate
              regularly, the lining of the uterus can become too thick.
              <br />
              This condition is common during puberty and perimenopause,
              polycystic ovary syndrome (PCOS) and hypothyroidism.
            </li>
            <li>
              When the blood does not clot properly, it can cause heavy
              bleeding.
            </li>
            <li>
              Medications — Blood thinners and aspirin can cause heavy menstrual
              bleeding. The copper intrauterine device (IUD) can
              <br />
              cause heavier menstrual bleeding, especially during the first year
              of use.
            </li>
            <li>
              Cancer — Heavy menstrual bleeding can be an early sign of
              endometrial cancer. Most cases of endometrial cancer are
              <br />
              diagnosed in women who are past menopause
            </li>
            <li>Sometimes, the cause is not known</li>
          </ul>
        </div>
        <br />
        <div className="detail">
          <p>
            Investigations:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="investigation"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formValues.investigation}
            </span>
          </p>
        </div>
        <div className="bulletin">
          <ul>
            <li>Few blood tests and</li>
          </ul>
        </div>
        <br />
        <div className="detail">
          <p>Tips:</p>
        </div>
        <div className="bulletin">
          <ul>
            <li>Drink plenty of water</li>
            <li>
              Take iron rich foods – Keerai especially Moringa leaves thrice a
              week ; dates, figs, karupattiif not diabetic ;<br />
              goat spleen twice a week if non vegetarian
            </li>
            <li>Drink Ginger / cinnamon water</li>
            <li>
              Flaxseeds - They have the ability to regulate the menstrual cycle
            </li>
            <li>Turmeric milk can ease the pain</li>
            <li>Hot water bag on the tummy can ease menstrual cramps</li>
            <li>Velakkennai(castor oil) massage over the tummy</li>
          </ul>
        </div>
        <p style={{ fontWeight: "600" }}>
          NEXT APPOINTMENT -{" "}
          <input
            name="nextappointment"
            onChange={handleChange}
            type="datetime-local"
            // type="date"
          />
        </p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>
      <div id="heavyBleedingReport">
        <div id="heavyBleedingReportWarp">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>
              HEAVY BLEEDING Template
            </h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("C/O Bleeding PV :", formValues.cobleedingpv)}
            {renderReportfield(
              "C/o Passing clots :",
              formValues.copassingclots
            )}
            {renderReportfield(
              "C/o pain during periods :",
              formValues.copainperiods
            )}
            {renderReportfield(
              "C/O bleeding after intercourse :",
              formValues.cobleedingintercourse
            )}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield(
              "C/O bleeding in between periods :",
              formValues.copainperiods
            )}
            {renderReportfield("Others :", formValues.others)}
            {renderReportfield("Menstrual H/O :", formValues.menstrualho)}
            {renderReportfield("LMP :", formValues.lmp)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("Cycles :", formValues.cycles)}
            {renderReportfield("Frequency :", formValues.frequency)}
            {renderReportfield("Pain during periods :", formValues.painperiods)}
            {renderReportfield("Obstetric h/o :", formValues.obstetricho)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {/* {renderReportfield("Cycles :",formValues.cycles)}
              {renderReportfield("Frequency :",formValues.frequency)} */}
            {renderReportfield("Sterilization :", formValues.sterilization)}
            {/* {renderReportfield("Obstetric h/o :",formValues.obstetricho)} */}
          </div>
          <div>
            <table
              style={{
                marginBottom: "10px",
                border: "1px solid black",
                width: "100%",
              }}
            >
              <thead>
                <tr>
                  {renderTableTH(
                    "Diabetes/ Hypertension/TB/ Hypothyroid/ Hyperthyroid/Nil/ Others"
                  )}
                  {renderTableTH("Duration")}
                  {renderTableTH("Medications")}
                </tr>
              </thead>
              <tbody>
                {rows.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele.diabeteshypertensiontoother)}
                      {renderTableTD(ele.duration)}
                      {renderTableTD(ele.medications)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>Past H/O</h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>
              On examination
            </h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield(
              "GC Fair, Hydration - Adequate : ",
              formValues.gcfair
            )}
            {renderReportfield("BP :", `${formValues.bp} mm/hg `)}
            {renderReportfield("PR :", formValues.pr)}
            {renderReportfield("Height :", `${formValues.height} cm`)}
            {renderReportfield("Weight :", `${formValues.weight} KGs`)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("BMI :", `${formValues.bmiValue} KG/m2`)}
            {renderReportfield("Per abdomen: ", formValues.perabdomen)}
            {renderReportfield("PS :", `${formValues.ps}`)}
            {renderReportfield("PV :", `${formValues.pv}`)}
            {renderReportfield("Pap Smear/HPV :", formValues.papsmear)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("Vaginal Swab :", `${formValues.vaginalswab}`)}
            {renderReportfield("Lab :", formValues.lab)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>
              Investigations
            </h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>
              CBC ,FBS ,HbA1C,TSH,FT4
            </h5>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>USG Pelvis</h5>
          </div>
          <div>
            <table
              style={{
                marginBottom: "10px",
                border: "1px solid black",
                width: "100%",
              }}
            >
              <thead>
                <tr>
                  {[
                    "Sno",
                    "Drug (Insert generic name)",
                    "Dosage NUMBERS",
                    "Frequency",
                    "Relationship with food",
                    "Duration",
                  ].map((ele, i) => {
                    return renderTableTH(ele);
                  })}
                </tr>
              </thead>
              <tbody>
                {investiRows.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ind + 1)}
                      {renderTableTD(ele.drug)}
                      {renderTableTD(ele.dosageno)}
                      {renderTableTD(ele.frequency)}
                      {renderTableTD(ele.relationwithfood)}
                      {renderTableTD(ele.duration)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderDiscPoint()}
            <h6 style={{ fontWeight: 500, marginRight: "5px" }}>
              Take your medications fully as per course as stopping hormonal
              pills in between can lead to bleeding again.
            </h6>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>
              Information Leaflet
            </h5>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5
              style={{ fontWeight: 600, marginRight: "5px", marginLeft: "5px" }}
            >
              Some of the causes of heavy bleeding
            </h5>
          </div>
          {[
            "Fibroids and polyps - Common bumps in uterus and inside the uterus",
            "Adenomyosis - Thick walls of uterus",
            "Hormonal imbalance and Irregular ovulation — If you do not ovulate regularly, the lining of the uterus can become too thick. This condition is common during puberty and perimenopause, polycystic ovary syndrome (PCOS) and hypothyroidism.",
            "When the blood does not clot properly, it can cause heavy bleeding.",
            "Medications — Blood thinners and aspirin can cause heavy menstrual bleeding. The copper intrauterine device (IUD) can cause heavier menstrual bleeding, especially during the first year of use.",
            "Cancer — Heavy menstrual bleeding can be an early sign of endometrial cancer. Most cases of endometrial cancer are diagnosed in women who are past menopause",
            "Sometimes, the cause is not known",
          ].map((ele, ind) => {
            return (
              <div style={{ display: "flex", marginTop: "10px" }}>
                {renderDiscPoint()}
                <h6
                  style={{
                    fontWeight: 500,
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                >
                  {ele}
                </h6>
              </div>
            );
          })}
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5
              style={{ fontWeight: 600, marginRight: "5px", marginLeft: "5px" }}
            >
              Investigations:
            </h5>
            <span>{formValues.investigation}</span>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5
              style={{ fontWeight: 600, marginRight: "5px", marginLeft: "5px" }}
            >
              Tips :
            </h5>
          </div>
          {[
            "Drink plenty of water",
            "Take iron rich foods – Keerai especially Moringa leaves thrice a week ; dates, figs, karupattiif not diabetic ;",
            "goat spleen twice a week if non vegetarian",
            "Drink Ginger / cinnamon water",
            "Flaxseeds - They have the ability to regulate the menstrual cycle",
            "Turmeric milk can ease the pain",
            "Hot water bag on the tummy can ease menstrual cramps",
            "Velakkennai(castor oil) massage over the tummy",
          ].map((ele, ind) => {
            return (
              <div style={{ display: "flex", marginTop: "10px" }}>
                {renderDiscPoint()}
                <h6
                  style={{
                    fontWeight: 500,
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                >
                  {ele}
                </h6>
              </div>
            );
          })}
          <div style={{ marginTop: "10px" }}>
            {renderReportfield(
              "Next Appointment",
              appointmentData.date?.split("-").reverse().join("-")
            )}
          </div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
